import React, { SVGProps } from 'react';

export default function PlayButtonIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="28.1428" cy="28.4692" r="28" fill="#0A0E14" />
      <path
        d="M27.9873 53.4692C41.7837 53.4692 53.0002 42.2467 53.0002 28.4693C53.0002 14.6917 41.7837 3.46924 27.9873 3.46924C14.2169 3.46924 3.00024 14.6917 3.00024 28.4693C3.00024 42.2467 14.2169 53.4692 27.9873 53.4692ZM23.3317 38.3418C22.16 39.0712 20.8113 38.4824 20.8113 37.2788V19.6963C20.8113 18.4927 22.2639 17.9819 23.3317 18.6333L37.7186 27.1405C38.7603 27.7712 38.7863 29.2458 37.7186 29.8505L23.3317 38.3418Z"
        fill="white"
      />
    </svg>
  );
}
